import { useState, useEffect } from 'react';
import { ChurchService } from '../models/ChurchService';
import { query, collection, where, orderBy, onSnapshot, limit } from '@firebase/firestore';
import { db } from '../firebase';

export const useServices = (churchId?: string, pageSize: number = 10) => {
  const [services, setServices] = useState<ChurchService[]>([]);
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (churchId) {
      const serviceQuery = query(
        collection(db, 'services'),
        where('church_id', '==', churchId),
        orderBy('date_of_service', 'desc'),
        limit(pageSize),
      );

      return onSnapshot(
        serviceQuery,
        (snap) => {
          const services = snap.docs.map((doc): ChurchService => {
            return {
              ...(doc.data() as ChurchService),
              id: doc.id,
            };
          });
          setServices(services);
          setLoading(false);
        },
        (err) => {
          setError(err.message);
          setLoading(false);
        },
      );
    } else {
      setServices([]);
    }
  }, [churchId]);

  return { services, error, loading };
};
